import React, { useState } from "react";
import { MockupFrame } from "./MockupFrame";

interface Comment {
	avatar: { initials: string; bg: string };
	author: string;
	timestamp: string;
	body: string;
	replyContext?: string;
	mention?: { name: string; color: string };
	badge?: { label: string; bg: string };
	reactions?: Array<{ emoji: string; count: number }>;
}

const COMMENTS: Comment[] = [
	{
		avatar: { initials: "SW", bg: "#db241e" },
		author: "Steven W.",
		timestamp: "Yesterday at 2:14 PM",
		body: "ARV looks strong at $620k based on the 3 comps on Eucalyptus. Roof was replaced in 2019 per seller disclosures. Main concern is the HVAC \u2014 it\u2019s original.",
		reactions: [{ emoji: "\uD83D\uDC4D", count: 2 }],
	},
	{
		avatar: { initials: "MR", bg: "#3b82f6" },
		author: "Maria R.",
		timestamp: "Yesterday at 3:41 PM",
		replyContext: "Steven W.: ARV looks strong at $620k...",
		body: "Got a quote from ",
		mention: { name: "@Jake Thompson", color: "#34d399" },
		reactions: [],
	},
	{
		avatar: { initials: "JT", bg: "#10b981" },
		author: "Jake Thompson",
		timestamp: "Today at 9:15 AM",
		body: "Confirmed \u2014 $8,200 for full HVAC swap (heat pump + ductwork). Can start within 2 weeks of close. Also noticed the water heater is from 2008, might want to budget $1,800 for that too.",
		badge: { label: "Contractor", bg: "bg-zinc-700/60" },
		reactions: [],
	},
	{
		avatar: { initials: "SW", bg: "#db241e" },
		author: "Steven W.",
		timestamp: "Today at 10:02 AM",
		body: "Good catch on the water heater. Updated the calculator \u2014 still showing 19.3% ROI with both items. Moving this to Escrow stage. \uD83C\uDFAF",
		reactions: [
			{ emoji: "\uD83C\uDFAF", count: 3 },
			{ emoji: "\uD83D\uDD25", count: 1 },
		],
	},
];

export function MockupComments() {
	const [hoveredComment, setHoveredComment] = useState<number | null>(null);
	const [composerFocused, setComposerFocused] = useState(false);

	return (
		<MockupFrame url="comps.red/deck/riverside/4821-magnolia">
			<div className="flex flex-col h-[420px]">
				{/* Property Header */}
				<div className="border-b border-white/5 px-4 py-3 bg-zinc-900/80">
					<div className="flex items-center justify-between">
						<div className="flex-1 min-w-0">
							<div className="flex items-center gap-2">
								<span className="text-sm font-semibold text-white">4821 Magnolia Ave, Riverside, CA 92506</span>
								<span className="text-[8px] font-bold uppercase px-1.5 py-0.5 rounded bg-[#db241e]/15 text-[#db241e]">Comp</span>
							</div>
							<div className="flex items-center gap-2 mt-1">
								<span className="text-[13px] font-bold text-white">$485,000</span>
								<span className="text-[9px] text-zinc-600 mx-0.5">&middot;</span>
								<span className="text-[10px] text-zinc-400">3bd / 2ba / 1,847 sqft / Built 1962</span>
								<span className="text-[9px] text-zinc-600 mx-0.5">&middot;</span>
								<span className="text-[8px] font-bold uppercase px-1.5 py-0.5 rounded bg-orange-500/15 text-orange-400">WARM</span>
							</div>
						</div>
						{/* Action buttons */}
						<div className="flex items-center gap-1 shrink-0 ml-3">
							{[
								"M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909M3.75 21h16.5A2.25 2.25 0 0022.5 18.75V5.25A2.25 2.25 0 0020.25 3H3.75A2.25 2.25 0 001.5 5.25v13.5A2.25 2.25 0 003.75 21z",
								"M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z",
							].map((d, i) => (
								<div key={i} className="h-6 w-6 rounded flex items-center justify-center text-zinc-600 hover:text-zinc-400 cursor-pointer transition-colors">
									<svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
										<path strokeLinecap="round" strokeLinejoin="round" d={d} />
									</svg>
								</div>
							))}
						</div>
					</div>
				</div>

				{/* Comments Section Header */}
				<div className="flex items-center justify-between px-4 py-2 border-b border-white/5">
					<div className="flex items-center gap-1.5">
						<svg className="h-3.5 w-3.5 text-zinc-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
							<path strokeLinecap="round" strokeLinejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
						</svg>
						<span className="text-[11px] font-semibold text-white">Comments</span>
						<span className="text-[10px] text-zinc-600">4</span>
					</div>
					<div className="flex items-center gap-1 text-[9px] text-zinc-600">
						<span>Newest first</span>
						<svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
							<path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
						</svg>
					</div>
				</div>

				{/* Comments Thread */}
				<div className="flex-1 overflow-y-auto px-4 py-2 space-y-1">
					{COMMENTS.map((comment, i) => (
						<div
							key={i}
							onMouseEnter={() => setHoveredComment(i)}
							onMouseLeave={() => setHoveredComment(null)}
							className={`rounded-lg px-3 py-2 transition-colors ${hoveredComment === i ? "bg-white/[0.03]" : ""}`}
						>
							{/* Reply context bar */}
							{comment.replyContext && (
								<div className="flex items-center gap-1.5 mb-1.5 pl-7">
									<div className="w-3 h-3 border-l-2 border-t-2 border-zinc-700 rounded-tl" />
									<span className="text-[9px] text-zinc-600 truncate">{comment.replyContext}</span>
								</div>
							)}

							<div className="flex items-start gap-2.5">
								{/* Avatar */}
								<div
									className="h-7 w-7 shrink-0 rounded-full flex items-center justify-center text-[9px] font-bold text-white"
									style={{ backgroundColor: comment.avatar.bg }}
								>
									{comment.avatar.initials}
								</div>

								{/* Content */}
								<div className="flex-1 min-w-0">
									<div className="flex items-center gap-2">
										<span className="text-[10px] font-semibold text-zinc-300">{comment.author}</span>
										{comment.badge && (
											<span className={`text-[8px] font-medium px-1.5 py-0.5 rounded ${comment.badge.bg} text-zinc-400`}>
												{comment.badge.label}
											</span>
										)}
										<span className="text-[9px] text-zinc-600">{comment.timestamp}</span>
									</div>

									<p className="text-[10px] text-zinc-300 mt-0.5 leading-relaxed">
										{comment.body}
										{comment.mention && (
											<>
												<span className="font-medium" style={{ color: comment.mention.color }}>{comment.mention.name}</span>
												<span> &mdash; HVAC replacement would be $8,200. Still pencils at 22% ROI even with that.</span>
											</>
										)}
									</p>

									{/* Reactions */}
									{comment.reactions && comment.reactions.length > 0 && (
										<div className="flex items-center gap-1 mt-1.5">
											{comment.reactions.map((reaction, j) => (
												<div
													key={j}
													className="flex items-center gap-1 rounded-full border border-white/10 bg-white/[0.04] px-1.5 py-0.5 text-[9px] cursor-pointer hover:border-white/20 transition-colors"
												>
													<span>{reaction.emoji}</span>
													<span className="text-zinc-400">{reaction.count}</span>
												</div>
											))}
										</div>
									)}
								</div>

								{/* Hover actions */}
								{hoveredComment === i && (
									<div className="flex items-center gap-0.5 shrink-0">
										{[
											"M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
											"M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3",
											"M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
										].map((d, j) => (
											<button key={j} className="h-5 w-5 rounded flex items-center justify-center text-zinc-600 hover:text-zinc-400 hover:bg-white/5 transition-colors">
												<svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
													<path strokeLinecap="round" strokeLinejoin="round" d={d} />
												</svg>
											</button>
										))}
									</div>
								)}
							</div>
						</div>
					))}
				</div>

				{/* Composer */}
				<div className="border-t border-white/5 px-3 py-2 shrink-0">
					<div
						className={`rounded-lg border bg-zinc-800/40 transition-colors ${
							composerFocused ? "border-[#db241e]/30 ring-1 ring-[#db241e]/10" : "border-white/5"
						}`}
						onClick={() => setComposerFocused(true)}
						onMouseLeave={() => setComposerFocused(false)}
					>
						{/* Toolbar */}
						<div className="flex items-center gap-0.5 px-2 py-1.5 border-b border-white/5">
							{["B", "I", "U"].map((icon) => (
								<div key={icon} className="rounded p-1 text-zinc-600 hover:text-zinc-400 hover:bg-white/5 cursor-pointer transition-colors text-[10px] font-bold w-6 h-6 flex items-center justify-center">
									{icon}
								</div>
							))}
							<div className="mx-1 h-3.5 w-px bg-zinc-700/60" />
							{[
								"M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
								"M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13",
							].map((d, j) => (
								<div key={j} className="rounded p-1 text-zinc-600 hover:text-zinc-400 hover:bg-white/5 cursor-pointer transition-colors">
									<svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
										<path strokeLinecap="round" strokeLinejoin="round" d={d} />
									</svg>
								</div>
							))}
						</div>
						{/* Input */}
						<div className="px-3 py-2 flex items-center justify-between">
							<span className={`text-[10px] transition-colors ${composerFocused ? "text-zinc-400" : "text-zinc-600"}`}>
								Add a comment...
							</span>
							<div className={`rounded-md p-1.5 transition-colors cursor-pointer ${composerFocused ? "bg-[#db241e] hover:bg-[#c41f1a]" : "bg-[#db241e]/50"}`}>
								<svg className="h-3.5 w-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
									<path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
								</svg>
							</div>
						</div>
					</div>
				</div>
			</div>
		</MockupFrame>
	);
}
